import moment from "../../__snowpack__/pkg/moment-timezone.js";
import {parse} from "../../__snowpack__/pkg/query-string.js";
import {isEmpty, find} from "../../__snowpack__/pkg/lodash.js";
export const getCurrencySymbol = (currencyCode) => {
  const countryList = !isEmpty(window.localStorage.countryList) ? JSON.parse(window.localStorage.countryList) : [];
  const isCurrencyCode = !isEmpty(currencyCode) ? currencyCode : "IDR";
  const findCountry = find(countryList, (item) => item.currencyCode === isCurrencyCode);
  return !isEmpty(findCountry) ? findCountry.currencySymbol : "Rp";
};
export const formatTime = (text) => {
  if (text) {
    return moment(text).format("DD-MM-YYYY HH:mm");
  } else {
    return "-";
  }
};
export const format = (num) => {
  let reg = /\d{1,3}(?=(\d{3})+$)/g;
  return (num + "").replace(reg, "$&,");
};
export const getCurrencyCode = () => {
  const country = parse(window.localStorage.userCountryInfo);
  return isEmpty(country) ? "IDR" : country.currencyCode;
};
export const formatCurrencyMoney = (price, currencyCode, showSymbol = true) => {
  currencyCode = currencyCode || getCurrencyCode();
  if (currencyCode === "SGD") {
    let formatter = new Intl.NumberFormat("en-US", {
      style: "decimal",
      maximumFractionDigits: 2
    });
    return "S$" + formatter.format(Number(price));
  }
  try {
    return new Intl.NumberFormat(currencyCode === "IDR" ? "id-ID" : "en-US", {
      style: showSymbol ? "currency" : void 0,
      currency: currencyCode,
      currencyDisplay: ["HKD", "TWD", "SGD"].includes(currencyCode || "IDR") ? "symbol" : "narrowSymbol",
      minimumFractionDigits: currencyCode === "IDR" ? 0 : void 0,
      maximumFractionDigits: 2
    }).format(price);
  } catch (e) {
    return getCurrencySymbol(currencyCode) + new Intl.NumberFormat(currencyCode === "IDR" ? "id-ID" : "en-US", {
      minimumFractionDigits: currencyCode === "IDR" ? 0 : void 0,
      maximumFractionDigits: 2
    }).format(price);
  }
};
export function fallbackVal(val, defaultVal) {
  const curDefaultVal = arguments.length > 1 ? defaultVal : "-";
  return val === 0 || val ? val : curDefaultVal;
}
export const formatVal = (val, defaultVal) => {
  return fallbackVal(val, defaultVal);
};
export const formatMoney = (value, language) => {
  if (!language)
    language = "id";
  if (typeof value !== "number" && !value)
    return "Rp 0";
  try {
    if (typeof value === "string") {
      value = Number(value) - 0;
    }
    return value.toLocaleString(language).replace(/^/, "Rp ");
  } catch (error) {
    return "Rp 0";
  }
};
export const formatValNum = (val, defaultVal) => {
  const curDefaultVal = defaultVal === 0 || defaultVal ? defaultVal : 0;
  return val === 0 || val ? val : curDefaultVal;
};
